<div class="form-row">
  <div class="form-group col-md-4">
    <label>Warehouse</label>
    <select class='form-control' [class.is-invalid]='this.warehouseLocation.warehouseId === -1'
      (change)='this.warehouseLocation.warehouseId = +$event.target.value'>
      <option value='-1'>Select a warehouse</option>
      @for (item of this.warehouses; track item) {
        <option [value]='item.id' [selected]='this.warehouseLocation.warehouseId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label>Aisle</label>
    <input type="text" name='aisle' [(ngModel)]='this.warehouseLocation.aisle' [class.is-invalid]='!this.warehouseLocation.aisle' class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label>Shelf</label>
    <input type="text" name='shelf' [(ngModel)]='this.warehouseLocation.shelf' [class.is-invalid]='!this.warehouseLocation.shelf' class="form-control">
  </div>
  <div class="form-group col-md-12">
    <label>Description</label>
    <textarea name='description' [(ngModel)]="this.warehouseLocation.description" class="form-control"></textarea>
  </div>
</div>
